export default {"src":"/_next/static/media/block.11a29c05.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};